<div class="flex flex-col border-b w-full pb-3">
  <div class="flex flex-row text-sm color-primary">
    <span>{{item().cartikelnummer}}</span>
  </div>
  <div class="flex flex-row">
    <span class="font-bold">{{item()[5]}}</span>
  </div>
  @if (item()[26]) {
    <div class="flex flex-row">
      <span class="text-xs">{{item()[26]}}</span>
    </div>
  }
  @if (item()[27]) {
    <div class="flex flex-row">
      <span class="text-xs">{{item()[27]}}</span>
    </div>
  }
  @if (item()[28]) {
    <div class="flex flex-row">
      <span class="text-xs">{{item()[28]}}</span>
    </div>
  }
  @if (item()[29]) {
    <div class="flex flex-row">
      <span class="text-xs">{{item()[29]}}</span>
    </div>
  }
</div>

<div class="flex flex-col">
  @if (item()['lagerstand_gesamt'] !== null && item()['lagerstand_gesamt'] !== undefined) {
    <div class="flex items-center justify-between py-2 border-b">
      {{ '#WWS_CORE.FOK.ARTSTAMM.MASTER_DETAIL.LAGERSTAND' | translate }} <span>{{ (item()['lagerstand_gesamt'] || 0) | number:'1.2-2' }} {{item()['lagereh']}}</span>
    </div>
  }
  @if (item()['21'] !== null && item()['21'] !== undefined) {
    <div class="flex items-center justify-between py-2 border-b">
      {{ '#WWS_CORE.FOK.ARTSTAMM.MASTER_DETAIL.VKPREIS' | translate }} <span>{{ (item()['21'] || 0) | currency:'EUR' }}</span>
    </div>
  }
  @if (item()['22'] !== null && item()['2'] !== undefined) {
    <div class="flex items-center justify-between py-2 border-b">
      {{ '#WWS_CORE.FOK.ARTSTAMM.MASTER_DETAIL.VKPREIS_INKL' | translate }} <span>{{ (item()['22'] || 0) | currency:'EUR' }}</span>
    </div>
  }
</div>
